module.exports = __webpack_public_path__ + "img/sleeve_flounce_length.2468039e.png";